export const notificationPanelLabels = {
  "en": {
    "open": "Open notifications",
    "close": "Close notifications",
    "title": "Notifications"
  },
  "hu": {
    "open": "Értesítések megnyitása",
    "close": "Értesítések bezárása",
    "title": "Értesítések"
  },
  "fr": {
    "open": "Ouvrir les notifications",
    "close": "Fermer les notifications",
    "title": "Notifications"
  },
  "ru": {
    "open": "Открыть уведомления",
    "close": "Закрыть уведомления",
    "title": "Уведомления"
  },
  "de": {
    "open": "Benachrichtigungen öffnen",
    "close": "Benachrichtigungen schließen",
    "title": "Benachrichtigungen"
  }
} as const;
